<template>
<div class="foruwizard-step">
  <h1 class="foruwizard-step-header">Вы великолепны!</h1>
  <div class="foruwizard-step-content">
    <div class="foruwizard-step-descr">Мы уже всё подготовили для вашего сайта.<br/> Вам осталось лишь сохранить и опубликовать результат! </div>
    <!--<div>-->
      <!--name - {{company.name}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--address - {{company.address}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--phone - {{company.phone}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--email - {{company.email}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--category - {{company.category}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--template_id - {{company.template_id}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--description - {{company.description}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--facebook - {{company.facebook}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm">-->
      <!--instagram - {{company.instagram}}-->
    <!--</div>-->
    <!--<div class="q-mt-sm q-mb-xl">-->
      <!--vkontakte - {{company.vkontakte}}-->
    <!--</div>-->

    </div>
    <div class="form-group foruwizard-form-group-bottom">
      <a href="javascript:void(0)" class="foruwizard-btn-salmon" @click="sendAllData">Завершить</a>
    </div>
  </div>
</div>
</template>

<script>
import VueCookies from 'vue-cookies';
export default {
  data: function(){
    return {
      company: {
        name: this.propObj.data.name,
        address: this.propObj.data.address,
        phone: this.propObj.data.phone,
        email: this.propObj.data.email,
        category: this.propObj.data.category,
        description: this.propObj.data.description,
        facebook: this.propObj.data.facebook,
        instagram: this.propObj.data.instagram,
        vkontakte: this.propObj.data.vkontakte,
        template_id: this.propObj.data.template_id
      }
    }
  },
  // props: ['myNextStep'],
  props: {
    propObj: {type: Object},
    myNextStep: {type: Function}
  },
  methods: {
    nextStep: function(){
      this.myNextStep();
    },
    // updateVars: function(){
    //   console.log(this.addrtext);
    //   this.myaddr.text = this.addrtext
    //   console.log(this.myaddr);
    //   this.$emit('updateaddr', this.myaddr)
    // },
    sendAllData: function(){
      console.log(this);
      let str = JSON.stringify(this.company);
      let strb64 = btoa(unescape(encodeURIComponent(str)));
      if(window.location.host.indexOf("localhost") > -1) {
        console.log("SETTING COOKI");
        console.log(strb64);
        window.$cookies.set("wizardata", strb64, null, null, "localhost");
      }else{
        window.$cookies.set("wizardata", strb64, null, null, "fo.ru");
      }
      if(this.$parent.authorized){
        window.location.href = this.$parent.homeUrl;
      }else{
        window.location.href = this.$parent.loginUrl;
      }
    }
  }

}
</script>

<style >
</style>
